import withLoader from "../../../components/layouts/WithLoader";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { useState } from "react";
import SalesService from "../../../services/SellingService";

const TransfertAccountsEspece = ({ startLoading, stopLoading }) => {
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [amount, setAmount] = useState();

  const changeAmount = (event) => {
    setAmount(event.target.value);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const payerBill = (e) => {
    if (amount === "") {
      console.log("amount", amount);

      // toast.error("Erreur : le champ montant  est vide");
    } else {
      let payFactureOrAvance = {
        idUser: getCurrentUserId(),
        idBaDestination: parseInt(localStorage.getItem("idBaDestination")),
        idBaSource: parseInt(localStorage.getItem("idBaSource")),
        typePayement: 0,
        ammountPayed: amount,
        urlFile: "any",
      };
      console.log(payFactureOrAvance);
      startLoading();
      SalesService.transfertAccount(payFactureOrAvance)

        .then((response) => {
          console.log(response);
          if (response.data["error"]) {
            //   toast.error("Error : il ya un probléme");
          } else {
            //   toast.success("ajouté avec succès");
            // this.refreshPage();
          }
        })
        .catch((error) => {
          console.log("error", error);
          // toast.error("Error : il ya un probléme");

          //   this.refreshPage();
        })
        .finally(() => {
          stopLoading();
        });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <label>Transfert par espèce: </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            //   max={this.props.restToPay.toString()}
            class="form-control"
            placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>

        <div class="col-12">
          <button
            type="submit"
            onClick={payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default withLoader(TransfertAccountsEspece);
